<p-accordion-panel [value]="value">
  <p-accordion-header>
    {{title}}
  </p-accordion-header>
  <p-accordion-content>
    <ng-content></ng-content>
  </p-accordion-content>
</p-accordion-panel>